// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/assets/images/page_loader.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=============================================================
                consultant Schedules Css
===============================================================*/
.rbc-btn {
    color: inherit;
    font: inherit;
    margin: 0;
}

button.rbc-btn {
    overflow: visible;
    text-transform: none;
    -webkit-appearance: button;
    cursor: pointer;
}

button[disabled].rbc-btn {
    cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
    border: 0;
    padding: 0;
}

.rbc-calendar {
    box-sizing: border-box;
    height: 100%;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    box-shadow: 0px 0px 10px #b5b1b1;
    padding: 5px;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
    box-sizing: inherit;
}

.rbc-abs-full,
.rbc-row-bg {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.rbc-ellipsis,
.rbc-event-label,
.rbc-row-segment .rbc-event-content,
.rbc-show-more {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rbc-rtl {
    direction: rtl;
}

.rbc-off-range {
    color: #999999;
}

.rbc-off-range-bg {
    background: #e5e5e5;
}

.rbc-header {
    overflow: hidden;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 3px;
    text-align: center;
    vertical-align: middle;
    font-weight: bold;
    font-size: 90%;
    min-height: 0;
    border-bottom: 1px solid #ddd;
}

.rbc-header+.rbc-header {
    border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-header+.rbc-header {
    border-left-width: 0;
    border-right: 1px solid #ddd;
}

.rbc-header>a,
.rbc-header>a:active,
.rbc-header>a:visited {
    color: inherit;
    text-decoration: none;
}

.rbc-row-content {
    position: relative;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none;
    z-index: 4;
}

.rbc-today {
    background-color: #eaf6ff;
}

.rbc-toolbar {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;
}

.rbc-toolbar .rbc-toolbar-label {
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    padding: 0 10px;
    text-align: center;
}

.rbc-toolbar button {
    color: #373a3c;
    display: inline-block;
    margin: 0;
    text-align: center;
    vertical-align: middle;
    background: none;
    background-image: none;
    border: 0px solid #ccc;
    padding: 0.375rem 1rem;
    border-radius: 25px;
    line-height: normal;
    white-space: nowrap;
}

.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
    background-image: none;
    box-shadow: 0px 2px 5px #636363;
    background-color: #e1241a;
    color: #ffffff;
}

.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button.rbc-active:focus {
    color: #ffffff;
    background-color: #e1241a;
    outline: 0px;
    box-shadow: 0px 2px 5px #636363;
}

.rbc-toolbar button:focus,
.rbc-toolbar button:hover {
    color: #ffffff;
    background-color: #e1241a;
    outline: 0px;
    box-shadow: 0px 2px 5px #636363;
}

.rbc-btn-group {
    display: inline-block;
    white-space: nowrap;
}

.rbc-btn-group>button:nth-child(4n) {
    display: none;
}

.rbc-btn-group button+button {
    margin-left: -1px;
}

.rbc-rtl .rbc-btn-group button+button {
    margin-left: 0;
    margin-right: -1px;
}

.rbc-btn-group+.rbc-btn-group,
.rbc-btn-group+button {
    margin-left: 10px;
}

.rbc-event {
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 2px 5px;
    background-color: #3174ad;
    border-radius: 5px;
    color: #fff;
    cursor: pointer;
    width: 100%;
    text-align: left;
}

.rbc-event.rbc-selected {
    background-color: #265985;
}

.rbc-event:focus {
    outline: 5px auto #3b99fc;
}

.rbc-event-label {
    font-size: 80%;
}

.rbc-event-overlaps {
    box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.rbc-event-continues-later {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.rbc-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
}

.rbc-row-segment {
    padding: 0 1px 1px 1px;
}

.rbc-selected-cell {
    background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
    background-color: rgba(255, 255, 255, 0.3);
    z-index: 4;
    font-weight: bold;
    font-size: 85%;
    height: auto;
    line-height: normal;
    white-space: nowrap;
}

.rbc-month-view {
    position: relative;
    border: 1px solid #ddd;

    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    width: 100%;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none;
    height: 100%;
}

.rbc-month-header {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
}

.rbc-month-row {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    -webkit-flex-basis: 0px;
    -ms-flex-preferred-size: 0px;
    flex-basis: 0px;
}

.rbc-month-row+.rbc-month-row {
    border-top: 1px solid #ddd;
}

.rbc-date-cell {
    -webkit-flex: 1 1 0;
    -ms-flex: 1 1 0px;
    flex: 1 1 0;
    min-width: 0;
    padding-right: 5px;
    text-align: right;
    min-height: 100px;
}

.rbc-date-cell.rbc-now {
    font-weight: bold;
}

.rbc-date-cell>a,
.rbc-date-cell>a:active,
.rbc-date-cell>a:visited {
    color: inherit;
    text-decoration: none;
}

.rbc-row-bg {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    overflow: hidden;
}

.rbc-day-bg {
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
}

.rbc-day-bg+.rbc-day-bg {
    border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-day-bg+.rbc-day-bg {
    border-left-width: 0;
    border-right: 1px solid #ddd;
}

.rbc-overlay {
    position: absolute;
    z-index: 5;
    border: 1px solid #e5e5e5;
    background-color: #fff;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
    padding: 10px;
}

.rbc-overlay>*+* {
    margin-top: 1px;
}

.rbc-overlay-header {
    border-bottom: 1px solid #e5e5e5;
    margin: -10px -10px 5px -10px;
    padding: 2px 10px;
}

.rbc-agenda-view {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    overflow: auto;
}

.rbc-agenda-view table.rbc-agenda-table {
    width: 100%;
    border: 1px solid #ddd;
    border-spacing: 0;
    border-collapse: collapse;
}

.rbc-agenda-view table.rbc-agenda-table tbody>tr>td {
    padding: 5px 10px;
    vertical-align: top;
}

.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
    padding-left: 15px;
    padding-right: 15px;
    text-transform: lowercase;
}

.rbc-agenda-view table.rbc-agenda-table tbody>tr>td+td {
    border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody>tr>td+td {
    border-left-width: 0;
    border-right: 1px solid #ddd;
}

.rbc-agenda-view table.rbc-agenda-table tbody>tr+tr {
    border-top: 1px solid #ddd;
}

.rbc-agenda-view table.rbc-agenda-table thead>tr>th {
    padding: 3px 5px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead>tr>th {
    text-align: right;
}

.rbc-agenda-time-cell {
    text-transform: lowercase;
}

.rbc-agenda-time-cell .rbc-continues-after:after {
    content: " »";
}

.rbc-agenda-time-cell .rbc-continues-prior:before {
    content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
    white-space: nowrap;
}

.rbc-agenda-event-cell {
    width: 100%;
}

.rbc-time-column {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 100%;
}

.rbc-time-column .rbc-timeslot-group {
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.rbc-timeslot-group {
    border-bottom: 1px solid #ddd;
    min-height: 40px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-flow: column nowrap;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
}

.rbc-label {
    padding: 0 5px;
}

.rbc-day-slot {
    position: relative;
}

.rbc-day-slot .rbc-events-container {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;

    top: 0;
}

.rbc-day-slot .rbc-events-container.rbc-is-rtl {
    left: 10px;
    right: 0;
}

.rbc-day-slot .rbc-event {
    border: 1px solid #265985;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    max-height: 100%;
    min-height: 20px;
    -webkit-flex-flow: column wrap;
    -ms-flex-flow: column wrap;
    flex-flow: column wrap;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    overflow: hidden;
    position: absolute;
}

.rbc-day-slot .rbc-event-label {
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
    padding-right: 5px;
    width: auto;
}

.rbc-day-slot .rbc-event-content {
    width: 100%;
    -webkit-flex: 1 1 0;
    -ms-flex: 1 1 0px;
    flex: 1 1 0;
    word-wrap: break-word;
    line-height: 1;
    height: 100%;
    min-height: 1em;
}

.rbc-day-slot .rbc-time-slot {
    border-top: 1px solid #f7f7f7;
}

.rbc-time-view-resources .rbc-time-gutter,
.rbc-time-view-resources .rbc-time-header-gutter {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    background-color: white;
    border-right: 1px solid #ddd;
    z-index: 10;
    margin-right: -1px;
}

.rbc-time-view-resources .rbc-time-header {
    overflow: hidden;
}

.rbc-time-view-resources .rbc-time-header-content {
    min-width: auto;
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
    -webkit-flex-basis: 0px;
    -ms-flex-preferred-size: 0px;
    flex-basis: 0px;
}

.rbc-time-view-resources .rbc-time-header-cell-single-day {
    display: none;
}

.rbc-time-view-resources .rbc-day-slot {
    min-width: 140px;
}

.rbc-time-view-resources .rbc-header,
.rbc-time-view-resources .rbc-day-bg {
    width: 140px;
    -webkit-flex: 1 1 0;
    -ms-flex: 1 1 0px;
    flex: 1 1 0;
    -webkit-flex-basis: 0 px;
    -ms-flex-preferred-size: 0 px;
    flex-basis: 0 px;
}

.rbc-time-header-content+.rbc-time-header-content {
    margin-left: -1px;
}

.rbc-time-slot {
    -webkit-flex: 1 0 0;
    -ms-flex: 1 0 0px;
    flex: 1 0 0;
}

.rbc-time-slot.rbc-now {
    font-weight: bold;
}

.rbc-day-header {
    text-align: center;
}

.rbc-slot-selection {
    z-index: 10;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 75%;
    width: 100%;
    padding: 3px;
}

.rbc-slot-selecting {
    cursor: move;
}

.rbc-time-view {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    border: 1px solid #ddd;
    min-height: 0;
}

.rbc-time-view .rbc-time-gutter {
    white-space: nowrap;
}

.rbc-time-view .rbc-allday-cell {
    box-sizing: content-box;
    width: 100%;
    height: 100%;
    position: relative;
}

.rbc-time-view .rbc-allday-cell+.rbc-allday-cell {
    border-left: 1px solid #ddd;
}

.rbc-time-view .rbc-allday-events {
    position: relative;
    z-index: 4;
}

.rbc-time-view .rbc-row {
    box-sizing: border-box;
    min-height: 20px;
}

.rbc-time-header {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex: 0 0 auto;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
}

.rbc-time-header.rbc-overflowing {
    border-right: 1px solid #ddd;
}

.rbc-rtl .rbc-time-header.rbc-overflowing {
    border-right-width: 0;
    border-left: 1px solid #ddd;
}

.rbc-time-header>.rbc-row:first-child {
    border-bottom: 1px solid #ddd;
}

.rbc-time-header>.rbc-row.rbc-row-resource {
    border-bottom: 1px solid #ddd;
}

.rbc-time-header-cell-single-day {
    display: none;
}

.rbc-time-header-content {
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    min-width: 0;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-time-header-content {
    border-left-width: 0;
    border-right: 1px solid #ddd;
}

.rbc-time-content {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex: 1 0 0%;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    width: 100%;
    border-top: 2px solid #ddd;
    overflow-y: auto;
    position: relative;
}

.rbc-time-content>.rbc-time-gutter {
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
}

.rbc-time-content>*+*>* {
    border-left: 1px solid #ddd;
}

.rbc-rtl .rbc-time-content>*+*>* {
    border-left-width: 0;
    border-right: 1px solid #ddd;
}

.rbc-time-content>.rbc-day-slot {
    width: 100%;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-select: none;
}

.rbc-current-time-indicator {
    position: absolute;
    z-index: 3;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #74ad31;
    pointer-events: none;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle,
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
    margin-left: -8px;
    position: absolute;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle,
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
    box-sizing: content-box;
    position: absolute;
    border: 8px solid transparent;
    height: 0;
    width: 1px;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
    content: "";
    z-index: -1;
    border-width: 8px;
    left: -8px;
    border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {
    top: 0;
    margin-top: -8px;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
    border-top: none;
    border-bottom-color: #f0f0f0;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
    top: -1px;
    border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle,
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
    bottom: 0;
    margin-bottom: -8px;
}

.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle,
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
    border-bottom: none;
    border-top-color: #fff;
}

.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before,
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
    bottom: -1px;
    border-top-color: #aeaeae;
}

.react-datepicker-wrapper {
    display: inline-block;
}

.react-datepicker {

    font-size: 0.8rem;
    background-color: #fff;
    color: #000;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    display: inline-block;
    position: relative;
}

.react-datepicker--time-only .react-datepicker__triangle {
    left: 35px;
}

.react-datepicker--time-only .react-datepicker__time-container {
    border-left: 0;
}

.react-datepicker--time-only .react-datepicker__time {
    border-radius: 0.3rem;
}

.react-datepicker--time-only .react-datepicker__time-box {
    border-radius: 0.3rem;
}

.react-datepicker__triangle {
    position: absolute;
    left: 50px;
}

.react-datepicker-popper {
    z-index: 1;
}

.react-datepicker-popper[data-placement^="bottom"] {
    margin-top: 10px;
}

.react-datepicker-popper[data-placement^="top"] {
    margin-bottom: 10px;
}

.react-datepicker-popper[data-placement^="right"] {
    margin-left: 8px;
}

.react-datepicker-popper[data-placement^="right"] .react-datepicker__triangle {
    left: auto;
    right: 42px;
}

.react-datepicker-popper[data-placement^="left"] {
    margin-right: 8px;
}

.react-datepicker-popper[data-placement^="left"] .react-datepicker__triangle {
    left: 42px;
    right: auto;
}

.react-datepicker__header {
    text-align: center;
    background-color: #f0f0f0;
    border-bottom: 1px solid #aeaeae;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    padding-top: 8px;
    position: relative;
}

.react-datepicker__header--time {
    padding-bottom: 8px;
    padding-left: 5px;
    padding-right: 5px;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
    display: inline-block;
    margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header {
    margin-top: 0;
    color: #000;
    font-weight: bold;
    font-size: 0.944rem;
}

.react-datepicker-time__header {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.react-datepicker__navigation {
    background: none;
    line-height: 1.7rem;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 10px;
    padding: 0;
    border: 0.45rem solid transparent;
    z-index: 1;
    height: 10px;
    width: 10px;
    text-indent: -999em;
    overflow: hidden;
}

.react-datepicker__navigation--previous {
    left: 10px;
    border-right-color: #ccc;
}

.react-datepicker__navigation--previous:hover {
    border-right-color: #b3b3b3;
}

.react-datepicker__navigation--previous--disabled,
.react-datepicker__navigation--previous--disabled:hover {
    border-right-color: #e6e6e6;
    cursor: default;
}

.react-datepicker__navigation--next {
    right: 10px;
    border-left-color: #ccc;
}

.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 80px;
}

.react-datepicker__navigation--next:hover {
    border-left-color: #b3b3b3;
}

.react-datepicker__navigation--next--disabled,
.react-datepicker__navigation--next--disabled:hover {
    border-left-color: #e6e6e6;
    cursor: default;
}

.react-datepicker__navigation--years {
    position: relative;
    top: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.react-datepicker__navigation--years-previous {
    top: 4px;
    border-top-color: #ccc;
}

.react-datepicker__navigation--years-previous:hover {
    border-top-color: #b3b3b3;
}

.react-datepicker__navigation--years-upcoming {
    top: -4px;
    border-bottom-color: #ccc;
}

.react-datepicker__navigation--years-upcoming:hover {
    border-bottom-color: #b3b3b3;
}

.react-datepicker__month-container {
    float: left;
}

.react-datepicker__month {
    margin: 0.4rem;
    text-align: center;
}

.react-datepicker__time-container {
    float: right;
    border-left: 1px solid #aeaeae;
    width: 70px;
}

.react-datepicker__time-container--with-today-button {
    display: inline;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    position: absolute;
    right: -72px;
    top: 0;
}

.react-datepicker__time-container .react-datepicker__time {
    position: relative;
    background: white;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 70px;
    overflow-x: hidden;
    margin: 0 auto;
    text-align: center;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
    list-style: none;
    margin: 0;
    height: calc(195px + (1.7rem / 2));
    overflow-y: scroll;
    padding-right: 0px;
    padding-left: 0px;
    width: 100%;
    box-sizing: content-box;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
    height: 30px;
    padding: 5px 10px;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
    cursor: pointer;
    background-color: #f0f0f0;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
    background-color: #216ba5;
    color: white;
    font-weight: bold;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
    background-color: #216ba5;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
    color: #ccc;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
    cursor: default;
    background-color: transparent;
}

.react-datepicker__week-number {
    color: #ccc;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable {
    cursor: pointer;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
    border-radius: 0.3rem;
    background-color: #f0f0f0;
}

.react-datepicker__day-names,
.react-datepicker__week {
    white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
    color: #000;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
}

.react-datepicker__day {
    cursor: pointer;
}

.react-datepicker__day:hover {
    border-radius: 0.3rem;
    background-color: #f0f0f0;
}

.react-datepicker__day--today {
    font-weight: bold;
}

.react-datepicker__day--highlighted {
    border-radius: 0.3rem;
    background-color: #3dcc4a;
    color: #fff;
}

.react-datepicker__day--highlighted:hover {
    background-color: #32be3f;
}

.react-datepicker__day--highlighted-custom-1 {
    color: magenta;
}

.react-datepicker__day--highlighted-custom-2 {
    color: green;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range {
    border-radius: 0.3rem;
    background-color: #216ba5;
    color: #fff;
}

.react-datepicker__day--selected:hover,
.react-datepicker__day--in-selecting-range:hover,
.react-datepicker__day--in-range:hover {
    background-color: #1d5d90;
}

.react-datepicker__day--keyboard-selected {
    border-radius: 0.3rem;
    background-color: #2a87d0;
    color: #fff;
}

.react-datepicker__day--keyboard-selected:hover {
    background-color: #1d5d90;
}

.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
    background-color: rgba(33, 107, 165, 0.5);
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {
    background-color: #f0f0f0;
    color: #000;
}

.react-datepicker__day--disabled {
    cursor: default;
    color: #ccc;
}

.react-datepicker__day--disabled:hover {
    background-color: transparent;
}

.react-datepicker__input-container {
    position: relative;
    display: inline-block;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
    border: 1px solid transparent;
    border-radius: 0.3rem;
}

.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
    cursor: pointer;
}

.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
    border-top-color: #b3b3b3;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
    border-top-color: #ccc;
    float: right;
    margin-left: 20px;
    top: 8px;
    position: relative;
    border-width: 0.45rem;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
    background-color: #f0f0f0;
    position: absolute;
    width: 50%;
    left: 25%;
    top: 30px;
    z-index: 1;
    text-align: center;
    border-radius: 0.3rem;
    border: 1px solid #aeaeae;
}

.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
    cursor: pointer;
}

.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
    height: 150px;
    overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
    line-height: 20px;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
}

.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
    background-color: #ccc;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
    border-bottom-color: #b3b3b3;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
    border-top-color: #b3b3b3;
}

.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
    position: absolute;
    left: 15px;
}

.react-datepicker__close-icon {
    background-color: transparent;
    border: 0;
    cursor: pointer;
    outline: 0;
    padding: 0;
    vertical-align: middle;
    position: absolute;
    height: 16px;
    width: 16px;
    top: 25%;
    right: 7px;
}

.react-datepicker__close-icon::after {
    background-color: #216ba5;
    border-radius: 50%;
    bottom: 0;
    box-sizing: border-box;
    color: #fff;
    content: "\\00d7";
    cursor: pointer;
    font-size: 12px;
    height: 16px;
    width: 16px;
    line-height: 1;
    margin: -8px auto 0;
    padding: 2px;
    position: absolute;
    right: 0px;
    text-align: center;
}

.react-datepicker__today-button {
    background: #f0f0f0;
    border-top: 1px solid #aeaeae;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    padding: 5px 0;
    clear: left;
}

.react-datepicker__portal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 2147483647;
}

.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
    width: 3rem;
    line-height: 3rem;
}

@media (max-width: 400px),
(max-height: 550px) {

    .react-datepicker__portal .react-datepicker__day-name,
    .react-datepicker__portal .react-datepicker__day,
    .react-datepicker__portal .react-datepicker__time-name {
        width: 2rem;
        line-height: 2rem;
    }
}

.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
    font-size: 1.44rem;
}

.react-datepicker__portal .react-datepicker__navigation {
    border: 0.81rem solid transparent;
}

.react-datepicker__portal .react-datepicker__navigation--previous {
    border-right-color: #ccc;
}

.react-datepicker__portal .react-datepicker__navigation--previous:hover {
    border-right-color: #b3b3b3;
}

.react-datepicker__portal .react-datepicker__navigation--previous--disabled,
.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {
    border-right-color: #e6e6e6;
    cursor: default;
}

.react-datepicker__portal .react-datepicker__navigation--next {
    border-left-color: #ccc;
}

.react-datepicker__portal .react-datepicker__navigation--next:hover {
    border-left-color: #b3b3b3;
}

.react-datepicker__portal .react-datepicker__navigation--next--disabled,
.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {
    border-left-color: #e6e6e6;
    cursor: default;
}

.react-confirm-alert-blur {
    filter: url(#gaussian-blur);
    filter: blur(2px);
    -webkit-filter: blur(2px);
}

.react-confirm-alert-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999999;
    background-color: rgba(0, 0, 0, 0.6);
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    justify-content: center;
    -ms-align-items: center;
    align-items: center;
    opacity: 0;
    -webkit-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
    -moz-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
    -o-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
    animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
}

.react-confirm-alert {

    width: 400px;
    padding: 30px;
    text-align: center;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);
    color: #666;
}

.react-confirm-alert-svg {
    position: absolute;
    top: 0;
    left: 0;
}

.react-confirm-alert>h1 {
    margin-top: 0;
}

.react-confirm-alert>h3 {
    margin: 0;
    font-size: 16px;
}

.react-confirm-alert-button-group {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.react-confirm-alert-button-group>button {
    outline: none;
    background: #898989;
    border: none;
    display: inline-block;
    padding: 6px 18px;
    color: #fff;
    margin-right: 10px;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
}

.react-confirm-alert-button-group>button:nth-child(1) {
    outline: none;
    background: #0088cc;
    border: none;
    display: inline-block;
    padding: 6px 18px;
    color: #fff;
    margin-right: 10px;
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
}

@-webkit-keyframes react-confirm-alert-fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@-moz-keyframes react-confirm-alert-fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@-o-keyframes react-confirm-alert-fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes react-confirm-alert-fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.calender-rightside {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
}

.calender-rightside .ant-select {
    width: 100%;
    border-radius: 0px;
}

.calender-rightside .ant-select-selection {
    background-color: #e1241a;
    color: #ffffff;
    border-radius: 0px;
}

.calender-rightside .ant-select-arrow {
    color: #ffffff;
}

.calender-rightside .item p {
    color: #000000;
    font-size: 12px;
}

.calender-rightside .item p a {
    width: 20px;
    display: inline-block;
    color: green;
}

.calender-rightside .item p b {
    font-weight: 400;
}

.calender-rightside .item p span {
    background: #ffffff;
    color: #06b4e0;
    padding: 2px 5px;
    font-size: 11px;
    width: 70px;
    display: inline-block;
    text-align: center;
    float: right;
}

.soloprofilepage .progressbar {
    margin-top: 40px;
}

.soloprofilepage .progressbar .stepwizard-step p {
    margin-top: 10px;
    margin-left: -15%;
    font-size: 10px;
}

.soloprofilepage .progressbar .stepwizard-step.p2 p {
    margin-left: -5%;
}

.soloprofilepage .progressbar .stepwizard-row {
    display: table-row;
    width: 100%;
}

.soloprofilepage .progressbar .stepwizard {
    display: table;
    width: 80%;
    position: relative;
    margin: auto;
}

.soloprofilepage .progressbar .stepwizard-step button[disabled] {
    opacity: 1 !important;
    filter: alpha(opacity=100) !important;
}

.soloprofilepage .progressbar .stepwizard-row:before {
    top: 25%;
    bottom: 0;
    position: absolute;
    content: " ";
    width: 68%;
    height: 1px;
    background-color: #ccc;
}

.soloprofilepage .progressbar .stepwizard-step {
    display: table-cell;
    position: relative;
    width: 330px;
}

.soloprofilepage .progressbar .btn-circle {
    width: 30px;
    height: 30px;
    text-align: center;
    padding: 6px 0;
    font-size: 12px;
    line-height: 1.428571429;
    border-radius: 15px;
    background: #f0f1f6;
}

.soloprofilepage .progressbar .btn-primary {
    color: #fff;
    background-color: #e1362d;
    width: 40px;
    height: 40px;
    line-height: 20px;
    border-radius: 50%;
    border: 0px;
    padding: 10px;
}

.soloprofilepage .progressbar .btn-primary .fa-circle {
    color: #ffffff;
}

.soloprofilepage .progressbar .fa-circle {
    color: #e1362d;
}

.myModalconfirmdes .close {
    float: inherit;
    background: #dadbe6;
    opacity: 1;
    display: block;
    margin: auto;
    margin-right: 0px;
    margin-top: 10px;
    color: #ffffff;
    padding: 0px 0px 5px 0px;
    width: 35px;
    border-radius: 50%;
    height: 35px;
    line-height: 30px;
    text-align: center;
    top: 0px;
    position: absolute;
    font-size: 35px;
    font-weight: 100;
    right: 10px;
}

.myModalconfirmdes .close:hover,
.myModalconfirmdes .close:focus {
    opacity: 1 !important;
    background: #bcbaba;
    outline: 0px;
}

.myModalconfirmdes .modal-content {
    background: #f0f1f7;
    border-radius: 10px;
    width: 600px;
    margin: auto;
    border: 0px;
    margin-top: 20px;
}

.myModalconfirmdes .modal-content.modal-content22 {
    color: #e1362d;
    font-size: 32px;
    text-align: center;
    margin: 0 10px;
    width: calc(100% - 20px);
    border-radius: 0px;
    padding: 10px 0;
    margin-bottom: 2px;
    background: transparent;
    border: 0px;
    padding-top: 30px;
}

.myModalconfirmdes .modal-content.modal-content22 b {
    font-weight: normal;
}

.myModalconfirmdes .modal-title {
    font-size: 28px;
    font-weight: 400;
    padding-right: 20px;
}

.myModalconfirmdes p {
    margin: 0px;
    padding-top: 10px;
}

.myModalconfirmdes p.p1 {
    font-size: 12px;
    font-weight: bold;
 
}

.myModalconfirmdes p.p2 {
    background: #fff;
    padding: 5px 10px;
    color: #cac7c7;
    border: 1px solid #cccccc;
    border-radius: 0px;

}

.myModalconfirmdes p.p2select {
    padding: 0px;
    color: #cac7c7;
    border: 0px solid #cccccc;
}

.myModalconfirmdes p.p2select .custom-select {
    border-radius: 0px;
    color: #cac7c7;
    height: 32px;
    padding: 4px 10px;
}

.myModalconfirmdes p.p2select input {
    border-radius: 0px;
    color: #cac7c7;
    height: 32px;
    padding: 4px 10px;
}

.myModalconfirmdes .row.no-gutters {
    border-bottom: 1px solid #cccccc;
    padding: 10px 0px;
    margin: 0px 10px;
}

.myModalconfirmdes .row.no-gutters:last-child {
    border: 0px;
}

.myModalconfirmdes p.p3 {
    text-align: right;
    font-size: 18px;
    font-weight: 600;
    color: #8a8383;

}

.myModalconfirmdes p.p3.p3new {
    padding: 0px;
    text-align: center;
}

#myModalService.myModalconfirmdes p.p3 {
    padding: 0px;
    font-size: 15px;
    line-height: 2.2;
}

.myModalconfirmdes .timings span {
    line-height: 2.2;
}

.myModalconfirmdes .timings p.p2select {
    float: right;
    width: 75%;
}

#update-event.myModalconfirmdes ul,
#myModalService.myModalconfirmdes ul {
    padding: 0px;
    text-align: right;
}

.myModalconfirmdes ul li {
    display: inline-block;
    padding: 1px 4px;
    background: #ffffff;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    line-height: 27px;
    text-align: center;
    border: 1px solid #cccccc;
}

.myModalconfirmdes ul li a {
    display: block;
    color: #827d7d;
    text-decoration: none;
    font-size: 14px;
}

.myModalconfirmdes ul li.active {
    background: #dcd9d9;
    border-color: #2f2c2c;
}

.myModalconfirmdes ul li.active a {
    color: #222222;
    font-weight: 500;
}

.myModalconfirmdes .modal-header,
.myModalconfirmdes .modal-footer {
    background: #ffffff;
    padding-bottom: 5px;
}

#scheduleappointment .fc-button-primary {
    background: transparent;
    border: 0px;
    color: #071822;
    text-transform: capitalize;
    font-size: 16px;
    padding: 5px 15px;
    letter-spacing: 1px;
}

#scheduleappointment .fc-button-primary.fc-button-active,
#scheduleappointment .fc-button-primary:not(:disabled):active:focus,
#scheduleappointment .fc-button-primary:not(:disabled).fc-button-active:focus,
#scheduleappointment .fc-button-primary:hover {
    box-shadow: 0px 2px 5px #636363;
    background-color: #e1241a;
    color: #ffffff;
    border-radius: 30px;
    outline: 0px;
    opacity: 1;
}

#scheduleappointment .fc-toolbar h2 {
    margin: 0;
    font-size: 16px;
}

#scheduleappointment .fc-timeGrid-view .fc-day-grid {
    display: none;
}

#scheduleappointment hr.fc-divider {
    display: none;
}

#scheduleappointment .fc-nonbusiness {
    background: #cecece;
}

#scheduleappointment .fc-event .fc-content {
    color: #fff;
    font-size: 12px;
    text-align: center;
}

#scheduleappointment .fc {
    font-size: 1em;
    box-shadow: 0px 0px 10px #b5b1b1;
    padding: 5px;
}

#scheduleappointment .fc-toolbar.fc-header-toolbar {
    margin-bottom: 5px;
}

.eventColor {
    background: #cecece;
}

.loading {
    position: fixed;
    z-index: 999;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 50px;
    height: 50px;
}

.loading:before {
    content: "";
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
}

.loading:not(:required) {
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
}

.loading:not(:required):after {
    content: "";
    display: block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 35px;
    width: 35px;
    background-size: cover;
    padding: 40px !important;
    animation: none;
    border: none;
    z-index: 999;
    position: relative;
}

@-webkit-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@-moz-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@-o-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.main_content.soloprofilepage {
    background: #ffffff;
    margin-top: 80px;
}

ul.indicators {
    list-style-type: none;
    padding: 0px;
    margin-top: 15px;
}

ul.indicators li {
    padding: 5px 0px;
}

ul.indicators li.one .fa-square {
    color: #808080;
}

ul.indicators li.two .fa-square {
    color: #3788d8;
}

ul.indicators li.three .fa-square {
    color: #f2c9ca;
}

ul.indicators li.four .fa-square {
    color: #5bff31;
}

ul.indicators li.green .fa-square {
    color: #3788d8;
}

ul.indicators li.white .fa-square {
    color: #ffffff;
}

.main_cal_indicate ul.indicators li.four span {
    background: repeating-linear-gradient(45deg,
            #93fa93,
            #93fa93 8px,
            #93fa93 8px,
            #93fa93 20px);
}

.main_cal_indicate ul.indicators li.two span {
    background: repeating-linear-gradient(45deg,
            #3788d8,
            #3788d8 8px,
            #3788d8 8px,
            #3788d8 20px);
}

@media (max-width: 1300px) {
    .myModalconfirmdes .modal-content.modal-content22 {
        font-size: 25px;
    }

    .myModalconfirmdes .modal-title {
        font-size: 20px;
    }

    .myModalconfirmdes .modal-header img {
        width: 35px;
    }

    .myModalconfirmdes .row.no-gutters {
        padding: 5px 10px;
    }

    .myModalconfirmdes p.p2 {
        height: 32px;
        padding: 3px 10px;
    }
}

@media (max-width: 1100px) {
    #scheduleappointment .fc-button-primary {
        font-size: 12px;
        padding: 3px 10px;
    }

    #scheduleappointment .fc-toolbar h2 {
        font-size: 12px;
    }

    .calender-rightside .item p {
        display: flex;
        justify-content: space-between;
        text-align: center;
        font-size: 10px;
    }

    .calender-rightside .item p span {
        height: 20px;
    }
}

@media (min-width: 991px) {
    #update-event.myModalconfirmdes .modal-dialog {
        height: 500px;
        width: 850px;
    }

    #myModalService.myModalconfirmdes .modal-dialog {
        height: 530px;
        width: 850px;
    }
}

@media screen and (max-width: 991px) {
    #scheduleappointment .fc-button-primary {
        font-size: 10px;
        padding: 3px 10px;
    }

    #scheduleappointment .fc-toolbar h2 {
        font-size: 10px;
    }

    .fc th {
        font-size: 10px;
    }

    .fc-ltr .fc-axis {
        font-size: 11px;
        text-align: center;
    }

    .calender-rightside .item p span {
        display: block;
        width: 100%;
        margin-top: 5px;
        float: inherit;
    }

    .calender-rightside .item p {
        font-size: 9px;
        font-weight: bold;
        display: block;
    }

    .soloprofilepage .progressbar .stepwizard {
        width: 100%;
    }

    .soloprofilepage .progressbar .stepwizard-step p {
        font-weight: bold;
        font-size: 10px;
    }

    .soloprofilepage .profiletabone .property-rrswatch a {
        font-size: 10px;
    }

    .soloprofilepage .profiletabone .property-rrswatch label {
        position: relative;
        top: 4px;
    }

    .soloprofilepage .profiletabone i {
        padding-top: 10px;
        padding-bottom: 20px;
        font-size: 10px;
        color: #8a8585;
        text-align: center;
        font-weight: 700;
    }

    ul.indicators li .fa-square {
        float: left;
        margin: 4px 10px 14px 0px;
    }

    ul.indicators li {
        padding: 7px 0px;
    }
}

.myModalconfirmdes .modal-dialog {
    height: calc(100vh - 80px);
}

@media screen and (max-width: 767px) {
    .myModalconfirmdes .modal-content {
        width: 100%;
    }

    .myModalconfirmdes .modal-content.modal-content22 {
        font-size: 18px;
    }

    .myModalconfirmdes .close {
        width: 27px;
        height: 28px;
        line-height: 28px;
        font-size: 20px;
    }

    .myModalconfirmdes .modal-title {
        font-size: 15px;
        font-weight: 600;
    }

    .myModalconfirmdes p.p2 {
        margin-bottom: 10px;
    }

    .myModalconfirmdes p {
        text-align: center;
    }

    .myModalconfirmdes p.p3 {
        text-align: center;
    }

    .myModalconfirmdes .modal-dialog {
        height: auto;
    }

    #moveDelete .modal-title {
        font-size: 15px;
        font-weight: 700;
    }

    #moveDelete .input-group {
        flex-direction: column;
    }

    #moveDelete .react-datepicker__input-container,
    #moveDelete .input-group-prepend {
        display: block;
    }

    .react-confirm-alert {
        width: 90%;
    }

    .main_content.soloprofilepage {
        margin-top: 60px;
    }
}

@media (max-width: 580px) {
    .fc-toolbar.fc-header-toolbar {
        flex-direction: column;
    }

    .fc-toolbar.fc-header-toolbar .fc-left {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }

    .fc-toolbar.fc-header-toolbar .fc-right {
        width: 100%;
    }

    .fc-toolbar.fc-header-toolbar .fc-right .fc-button-group {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }

    .fc-toolbar.fc-header-toolbar .fc-center {
        margin-bottom: 10px;
    }
}

@media (min-width: 320px) {
    .myModalconfirmdes .modal-dialog {
        max-width: 80%;
        margin: 1.75rem auto;
        margin-top: 50px;
        background: #ffffff;
    }
}

#moveDelete .input-group-prepend {
    float: left;
    margin-bottom: 15px;
}

#moveDelete .react-datepicker-wrapper {
    width: 100%;
}

#moveDelete .react-datepicker__input-container {
    width: 100%;
}

#moveDelete .col-form-label {
    text-align: right;
}

.new_modal_pop .form-para {
  
    margin-bottom: 20px;
}

.new_modal_pop .form-para span {
  
    font-size: 13px;
    color: #909090;
}

.new_modal_pop .form-para p {
  
    font-size: 16px;
    color: #000000;
    margin-bottom: 0px;
}

.new_modal_pop .form-para p.p2 {
    height: 38px;
    background: #ffffff;
    border: 1px solid #cccccc;
    padding: 7px 10px;
    border-radius: 5px;
    color: #4e4e4e;
}

.new_modal_pop .form-para ul {
    padding: 0px;
    margin: 0px;
    list-style-type: none;
    margin-top: 10px;
}

.new_modal_pop .form-para ul li {
    display: inline-block;
}

.new_modal_pop .form-para ul li a {
    display: block;
    background: #9c9c9c;
    color: #ffffff;
    padding: 5px;
    border-radius: 50%;
    margin-right: 10px;
    margin-left: 0px;
    width: 30px;
    height: 30px;
    font-size: 13px;
    text-align: center;
    line-height: 20px;
  
}

.new_modal_pop .form-para ul li a:hover {
    color: #ffffff;
}

.new_modal_pop .form-para ul li.active a {
    background: #e32726;
}

.main_cal_indicate ul.indicators li {
    display: inline-block;
    margin-right: 15px;
}

#moveDelete.modal .main-pop h4.modal-title {
  
    font-size: 18px;
    padding: 20px 10px;
    font-weight: 400;
    text-align: center;
    color: #b7b7b7;
    margin-bottom: 10px;
    padding-top: 0px;
}

#moveDelete.modal .main-pop .form-group {
    position: relative;
    margin-bottom: 18px;
    padding-top: 20px;
}

#moveDelete.modal .main-pop .form-group label {
    position: absolute;
    top: -3px;
    left: 0;
    z-index: 9;
    font-size: 14px;
    color: #000000;
    
    font-weight: 500;
    padding: 0px;
}

#moveDelete.modal .main-pop .form-group .form-control {
    margin-bottom: 0px;
}

#moveDelete.modal .main-pop .form-group .custom-select {
    height: 42px;
    padding: 0.375rem 0.75rem;
    padding-left: 16px;
    border: 1px solid #bfbfbf;
    outline: 0px;
    box-shadow: none;
}

#moveDelete.modal .main-pop .form-group.form-group2 label {
  
    position: initial;
    padding-left: 0px;
    font-size: 14px;
    color: #a7a7a7;
    padding-bottom: 0px;
    margin: 0px;
}

#moveDelete.modal .main-pop .form-group.form-group2 {
    margin-bottom: 0px;
}

#moveDelete.modal .main-pop .form-group.form-group2 p {
  
    color: #030c10;
    font-size: 16px;
    margin-top: -5px;
    margin-bottom: 5px;
}

#moveDelete.modal .accordion .card-header:after {
    font-family: "FontAwesome", sans-serif;
    float: right;
    content: "-";
    font-size: 23px;
    line-height: 20px;
}

#moveDelete.modal .accordion .card-header.collapsed:after {
    content: "+";
}

#moveDelete.modal .accordion .card .card-header {
  
    font-size: 18px;
    padding: 6px 10px;
    font-weight: 300;
    text-align: left;
    color: #b7b7b7;
    margin-bottom: 0;
    background: transparent;
}

#moveDelete.modal .accordion .card .card-header .card-title {
  
    font-size: 18px;
    font-weight: 300;
    text-align: left;
    color: #b7b7b7;
}

#moveDelete.modal .accordion .card-body {
    padding: 10px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

#moveDelete.modal .btn {
    padding: 4px 20px;
    font-size: 15px;

    border: 1px solid #dc3545;
    outline: 0px;
    box-shadow: none;
}

#moveDelete.modal .btn.btn-danger {
    background: #d02f22;
}

#moveDelete.modal .btn.btn-danger:hover {
    background: #ffffff;
    color: #d02f22;
}

#moveDelete.modal .btn.btn-primary {
    background: #007bff;
    border-color: #007bff;
}

#moveDelete.modal .btn.btn-primary:hover {
    background: #ffffff;
    border-color: #007bff;
    color: #007bff;
}

.new_modal_pop ul.appoint_list {
    padding: 0px;
    margin: 0px;
}

.new_modal_pop ul.appoint_list li {
    position: relative;
    list-style-type: none;
}

.new_modal_pop ul.appoint_list li a {
    position: relative;
    display: block;
    height: 40px;
    line-height: 40px;
    padding: 0;
    padding-left: 16px;
    padding-right: 56px;
    text-decoration: none;
    font-weight: 400;
    white-space: nowrap;
    color: #d0d0d0;
    font-size: 17px;
    
    border: 1px dashed #ededed;
}

.new_modal_pop ul.appoint_list li a span {
    position: absolute;
    right: 16px;
    top: 0;
    color: #717171;
}

.new_modal_pop hr {
    position: relative;
    clear: both;
    margin-top: 30px;
    margin-bottom: 30px;
    outline: none;
    border-top: 1px solid #ededed;
}

.new_modal_pop .new_inputt input {
    width: 100%;
    border: 1px solid #efefef;
    padding: 5px 10px;
    margin-bottom: 20px;
    height: 40px;
    color: #888888;
    outline: 0px;
}

#showDetails.new_modal_pop .ul_select_list {
    flex-direction: row;
}

#update-event .main-pop .form-group {
    position: relative;
    margin-bottom: 18px;
    padding-top: 20px;
}

#update-event .main-pop .col-form-label {
    position: absolute;
    top: -3px;
    left: 0;
    z-index: 9;
    font-size: 14px;
    color: #000000;
    
    font-weight: 500;
    padding: 0px;
}
/* #update-event .main-pop .form-group .form-para li.active{
    color: #0087ff;
} */

#update-event .main-pop .form-group .custom-select {
    height: 42px;
    padding: 0.375rem 0.75rem;
    padding-left: 16px;
    border: 1px solid #bfbfbf;
    outline: 0px;
    box-shadow: none;
}

#update-event .main-pop .form-group .form-control {
    border: solid 1px rgba(0, 0, 0, 0.2);
    height: 43px;
    outline: 0px;
    box-shadow: none !important;
    border-radius: 6px;
    margin-bottom: 0px;
    line-height: 30px;
}


.calendar-view-page-schedule .fc .fc-scroller{
    overflow: initial !important;
}`, "",{"version":3,"sources":["webpack://./app/pages/Consultant/Schedule/Schedules.css"],"names":[],"mappings":"AAAA;;gEAEgE;AAChE;IACI,cAAc;IACd,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,oBAAoB;IACpB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;;;;IAII,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,+BAA+B;IAC/B,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,SAAS;IACT,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;IACtB,+BAA+B;IAC/B,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;IAII,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0CAA0C;IAC1C,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;;IAEtB,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,sBAAsB;IACtB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,OAAO;AACX;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,gCAAgC;IAChC,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,QAAQ;;IAER,MAAM;AACV;;AAEA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,+BAA+B;IAC/B,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,wBAAwB;IACxB,gBAAgB;IAChB,OAAO;IACP,uBAAuB;IACvB,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,wBAAwB;IACxB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,OAAO;IACP,WAAW;IACX,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,OAAO;IACP,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;;;;;IAKI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;;;;;;;IAUI,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;IACT,UAAU;AACd;;AAEA;;;;;IAKI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,MAAM;IACN,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,4BAA4B;AAChC;;AAEA;;;;IAII,SAAS;IACT,mBAAmB;AACvB;;AAEA;;;;;;;;IAQI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;;;IAII,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;;;IAMI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,iCAAiC;IACjC,UAAU;IACV,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;IAGI,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;;IAGI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;;;;;IAMI,yBAAyB;AAC7B;;AAEA;;;IAGI,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;;IAGI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;;IAGI,aAAa;IACb,kBAAkB;AACtB;;AAEA;;;IAGI,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;IAGI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;;IAGI,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;;IAGI,4BAA4B;AAChC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;IAGI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,eAAe;IACf,UAAU;IACV,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,OAAO;IACP,MAAM;IACN,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;IACX,iBAAiB;AACrB;;AAEA;;;IAGI;;;QAGI,WAAW;QACX,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gEAAgE;IAChE,6DAA6D;IAC7D,2DAA2D;IAC3D,wDAAwD;AAC5D;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;;AAEtB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;;;IAII,+BAA+B;IAC/B,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mDAAmE;IACnE,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI,+BAA+B;QAC/B,4BAA4B;QAC5B,2BAA2B;QAC3B,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;QAC5B,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,4BAA4B;QAC5B,2BAA2B;QAC3B,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;QAC5B,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,4BAA4B;QAC5B,2BAA2B;QAC3B,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;QAC5B,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,4BAA4B;QAC5B,2BAA2B;QAC3B,0BAA0B;QAC1B,uBAAuB;IAC3B;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;QAC5B,yBAAyB;IAC7B;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;;;;yBAIqB;AACzB;;AAEA;IACI;;;;yBAIqB;AACzB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,eAAe;QACf,cAAc;QACd,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,oBAAoB;QACpB,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;IACV,eAAe;IACf,cAAc;;IAEd,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,eAAe;;IAEf,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,eAAe;;IAEf,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;IACV,eAAe;IACf,cAAc;;IAEd,gBAAgB;IAChB,YAAY;AAChB;AACA;;GAEG;;AAEH;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,4BAA4B;AAChC","sourcesContent":["/*=============================================================\n                consultant Schedules Css\n===============================================================*/\n.rbc-btn {\n    color: inherit;\n    font: inherit;\n    margin: 0;\n}\n\nbutton.rbc-btn {\n    overflow: visible;\n    text-transform: none;\n    -webkit-appearance: button;\n    cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n    cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\n\n.rbc-calendar {\n    box-sizing: border-box;\n    height: 100%;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-align-items: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n    box-shadow: 0px 0px 10px #b5b1b1;\n    padding: 5px;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n    box-sizing: inherit;\n}\n\n.rbc-abs-full,\n.rbc-row-bg {\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.rbc-ellipsis,\n.rbc-event-label,\n.rbc-row-segment .rbc-event-content,\n.rbc-show-more {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.rbc-rtl {\n    direction: rtl;\n}\n\n.rbc-off-range {\n    color: #999999;\n}\n\n.rbc-off-range-bg {\n    background: #e5e5e5;\n}\n\n.rbc-header {\n    overflow: hidden;\n    -webkit-flex: 1 0 0%;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding: 0 3px;\n    text-align: center;\n    vertical-align: middle;\n    font-weight: bold;\n    font-size: 90%;\n    min-height: 0;\n    border-bottom: 1px solid #ddd;\n}\n\n.rbc-header+.rbc-header {\n    border-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-header+.rbc-header {\n    border-left-width: 0;\n    border-right: 1px solid #ddd;\n}\n\n.rbc-header>a,\n.rbc-header>a:active,\n.rbc-header>a:visited {\n    color: inherit;\n    text-decoration: none;\n}\n\n.rbc-row-content {\n    position: relative;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-user-select: none;\n    z-index: 4;\n}\n\n.rbc-today {\n    background-color: #eaf6ff;\n}\n\n.rbc-toolbar {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 10px;\n    font-size: 16px;\n}\n\n.rbc-toolbar .rbc-toolbar-label {\n    -webkit-flex-grow: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    padding: 0 10px;\n    text-align: center;\n}\n\n.rbc-toolbar button {\n    color: #373a3c;\n    display: inline-block;\n    margin: 0;\n    text-align: center;\n    vertical-align: middle;\n    background: none;\n    background-image: none;\n    border: 0px solid #ccc;\n    padding: 0.375rem 1rem;\n    border-radius: 25px;\n    line-height: normal;\n    white-space: nowrap;\n}\n\n.rbc-toolbar button:active,\n.rbc-toolbar button.rbc-active {\n    background-image: none;\n    box-shadow: 0px 2px 5px #636363;\n    background-color: #e1241a;\n    color: #ffffff;\n}\n\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button.rbc-active:hover,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button.rbc-active:focus {\n    color: #ffffff;\n    background-color: #e1241a;\n    outline: 0px;\n    box-shadow: 0px 2px 5px #636363;\n}\n\n.rbc-toolbar button:focus,\n.rbc-toolbar button:hover {\n    color: #ffffff;\n    background-color: #e1241a;\n    outline: 0px;\n    box-shadow: 0px 2px 5px #636363;\n}\n\n.rbc-btn-group {\n    display: inline-block;\n    white-space: nowrap;\n}\n\n.rbc-btn-group>button:nth-child(4n) {\n    display: none;\n}\n\n.rbc-btn-group button+button {\n    margin-left: -1px;\n}\n\n.rbc-rtl .rbc-btn-group button+button {\n    margin-left: 0;\n    margin-right: -1px;\n}\n\n.rbc-btn-group+.rbc-btn-group,\n.rbc-btn-group+button {\n    margin-left: 10px;\n}\n\n.rbc-event {\n    border: none;\n    box-shadow: none;\n    margin: 0;\n    padding: 2px 5px;\n    background-color: #3174ad;\n    border-radius: 5px;\n    color: #fff;\n    cursor: pointer;\n    width: 100%;\n    text-align: left;\n}\n\n.rbc-event.rbc-selected {\n    background-color: #265985;\n}\n\n.rbc-event:focus {\n    outline: 5px auto #3b99fc;\n}\n\n.rbc-event-label {\n    font-size: 80%;\n}\n\n.rbc-event-overlaps {\n    box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n\n.rbc-event-continues-prior {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.rbc-event-continues-after {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-earlier {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n\n.rbc-event-continues-later {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.rbc-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n}\n\n.rbc-row-segment {\n    padding: 0 1px 1px 1px;\n}\n\n.rbc-selected-cell {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.rbc-show-more {\n    background-color: rgba(255, 255, 255, 0.3);\n    z-index: 4;\n    font-weight: bold;\n    font-size: 85%;\n    height: auto;\n    line-height: normal;\n    white-space: nowrap;\n}\n\n.rbc-month-view {\n    position: relative;\n    border: 1px solid #ddd;\n\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex: 1 0 0;\n    -ms-flex: 1 0 0px;\n    flex: 1 0 0;\n    width: 100%;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-user-select: none;\n    height: 100%;\n}\n\n.rbc-month-header {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n}\n\n.rbc-month-row {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    position: relative;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex: 1 0 0;\n    -ms-flex: 1 0 0px;\n    flex: 1 0 0;\n    -webkit-flex-basis: 0px;\n    -ms-flex-preferred-size: 0px;\n    flex-basis: 0px;\n}\n\n.rbc-month-row+.rbc-month-row {\n    border-top: 1px solid #ddd;\n}\n\n.rbc-date-cell {\n    -webkit-flex: 1 1 0;\n    -ms-flex: 1 1 0px;\n    flex: 1 1 0;\n    min-width: 0;\n    padding-right: 5px;\n    text-align: right;\n    min-height: 100px;\n}\n\n.rbc-date-cell.rbc-now {\n    font-weight: bold;\n}\n\n.rbc-date-cell>a,\n.rbc-date-cell>a:active,\n.rbc-date-cell>a:visited {\n    color: inherit;\n    text-decoration: none;\n}\n\n.rbc-row-bg {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-flex: 1 0 0;\n    -ms-flex: 1 0 0px;\n    flex: 1 0 0;\n    overflow: hidden;\n}\n\n.rbc-day-bg {\n    -webkit-flex: 1 0 0%;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n}\n\n.rbc-day-bg+.rbc-day-bg {\n    border-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-day-bg+.rbc-day-bg {\n    border-left-width: 0;\n    border-right: 1px solid #ddd;\n}\n\n.rbc-overlay {\n    position: absolute;\n    z-index: 5;\n    border: 1px solid #e5e5e5;\n    background-color: #fff;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n    padding: 10px;\n}\n\n.rbc-overlay>*+* {\n    margin-top: 1px;\n}\n\n.rbc-overlay-header {\n    border-bottom: 1px solid #e5e5e5;\n    margin: -10px -10px 5px -10px;\n    padding: 2px 10px;\n}\n\n.rbc-agenda-view {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex: 1 0 0;\n    -ms-flex: 1 0 0px;\n    flex: 1 0 0;\n    overflow: auto;\n}\n\n.rbc-agenda-view table.rbc-agenda-table {\n    width: 100%;\n    border: 1px solid #ddd;\n    border-spacing: 0;\n    border-collapse: collapse;\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody>tr>td {\n    padding: 5px 10px;\n    vertical-align: top;\n}\n\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n    padding-left: 15px;\n    padding-right: 15px;\n    text-transform: lowercase;\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody>tr>td+td {\n    border-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody>tr>td+td {\n    border-left-width: 0;\n    border-right: 1px solid #ddd;\n}\n\n.rbc-agenda-view table.rbc-agenda-table tbody>tr+tr {\n    border-top: 1px solid #ddd;\n}\n\n.rbc-agenda-view table.rbc-agenda-table thead>tr>th {\n    padding: 3px 5px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead>tr>th {\n    text-align: right;\n}\n\n.rbc-agenda-time-cell {\n    text-transform: lowercase;\n}\n\n.rbc-agenda-time-cell .rbc-continues-after:after {\n    content: \" »\";\n}\n\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n    content: \"« \";\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n    white-space: nowrap;\n}\n\n.rbc-agenda-event-cell {\n    width: 100%;\n}\n\n.rbc-time-column {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    min-height: 100%;\n}\n\n.rbc-time-column .rbc-timeslot-group {\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n\n.rbc-timeslot-group {\n    border-bottom: 1px solid #ddd;\n    min-height: 40px;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-flow: column nowrap;\n    -ms-flex-flow: column nowrap;\n    flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n    -webkit-flex: none;\n    -ms-flex: none;\n    flex: none;\n}\n\n.rbc-label {\n    padding: 0 5px;\n}\n\n.rbc-day-slot {\n    position: relative;\n}\n\n.rbc-day-slot .rbc-events-container {\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n\n    top: 0;\n}\n\n.rbc-day-slot .rbc-events-container.rbc-is-rtl {\n    left: 10px;\n    right: 0;\n}\n\n.rbc-day-slot .rbc-event {\n    border: 1px solid #265985;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    max-height: 100%;\n    min-height: 20px;\n    -webkit-flex-flow: column wrap;\n    -ms-flex-flow: column wrap;\n    flex-flow: column wrap;\n    -webkit-align-items: flex-start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    overflow: hidden;\n    position: absolute;\n}\n\n.rbc-day-slot .rbc-event-label {\n    -webkit-flex: none;\n    -ms-flex: none;\n    flex: none;\n    padding-right: 5px;\n    width: auto;\n}\n\n.rbc-day-slot .rbc-event-content {\n    width: 100%;\n    -webkit-flex: 1 1 0;\n    -ms-flex: 1 1 0px;\n    flex: 1 1 0;\n    word-wrap: break-word;\n    line-height: 1;\n    height: 100%;\n    min-height: 1em;\n}\n\n.rbc-day-slot .rbc-time-slot {\n    border-top: 1px solid #f7f7f7;\n}\n\n.rbc-time-view-resources .rbc-time-gutter,\n.rbc-time-view-resources .rbc-time-header-gutter {\n    position: -webkit-sticky;\n    position: sticky;\n    left: 0;\n    background-color: white;\n    border-right: 1px solid #ddd;\n    z-index: 10;\n    margin-right: -1px;\n}\n\n.rbc-time-view-resources .rbc-time-header {\n    overflow: hidden;\n}\n\n.rbc-time-view-resources .rbc-time-header-content {\n    min-width: auto;\n    -webkit-flex: 1 0 0;\n    -ms-flex: 1 0 0px;\n    flex: 1 0 0;\n    -webkit-flex-basis: 0px;\n    -ms-flex-preferred-size: 0px;\n    flex-basis: 0px;\n}\n\n.rbc-time-view-resources .rbc-time-header-cell-single-day {\n    display: none;\n}\n\n.rbc-time-view-resources .rbc-day-slot {\n    min-width: 140px;\n}\n\n.rbc-time-view-resources .rbc-header,\n.rbc-time-view-resources .rbc-day-bg {\n    width: 140px;\n    -webkit-flex: 1 1 0;\n    -ms-flex: 1 1 0px;\n    flex: 1 1 0;\n    -webkit-flex-basis: 0 px;\n    -ms-flex-preferred-size: 0 px;\n    flex-basis: 0 px;\n}\n\n.rbc-time-header-content+.rbc-time-header-content {\n    margin-left: -1px;\n}\n\n.rbc-time-slot {\n    -webkit-flex: 1 0 0;\n    -ms-flex: 1 0 0px;\n    flex: 1 0 0;\n}\n\n.rbc-time-slot.rbc-now {\n    font-weight: bold;\n}\n\n.rbc-day-header {\n    text-align: center;\n}\n\n.rbc-slot-selection {\n    z-index: 10;\n    position: absolute;\n    background-color: rgba(0, 0, 0, 0.5);\n    color: white;\n    font-size: 75%;\n    width: 100%;\n    padding: 3px;\n}\n\n.rbc-slot-selecting {\n    cursor: move;\n}\n\n.rbc-time-view {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    width: 100%;\n    border: 1px solid #ddd;\n    min-height: 0;\n}\n\n.rbc-time-view .rbc-time-gutter {\n    white-space: nowrap;\n}\n\n.rbc-time-view .rbc-allday-cell {\n    box-sizing: content-box;\n    width: 100%;\n    height: 100%;\n    position: relative;\n}\n\n.rbc-time-view .rbc-allday-cell+.rbc-allday-cell {\n    border-left: 1px solid #ddd;\n}\n\n.rbc-time-view .rbc-allday-events {\n    position: relative;\n    z-index: 4;\n}\n\n.rbc-time-view .rbc-row {\n    box-sizing: border-box;\n    min-height: 20px;\n}\n\n.rbc-time-header {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex: 0 0 auto;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n}\n\n.rbc-time-header.rbc-overflowing {\n    border-right: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n    border-right-width: 0;\n    border-left: 1px solid #ddd;\n}\n\n.rbc-time-header>.rbc-row:first-child {\n    border-bottom: 1px solid #ddd;\n}\n\n.rbc-time-header>.rbc-row.rbc-row-resource {\n    border-bottom: 1px solid #ddd;\n}\n\n.rbc-time-header-cell-single-day {\n    display: none;\n}\n\n.rbc-time-header-content {\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    min-width: 0;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    border-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-time-header-content {\n    border-left-width: 0;\n    border-right: 1px solid #ddd;\n}\n\n.rbc-time-content {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex: 1 0 0%;\n    -ms-flex: 1 0 0%;\n    flex: 1 0 0%;\n    -webkit-align-items: flex-start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    width: 100%;\n    border-top: 2px solid #ddd;\n    overflow-y: auto;\n    position: relative;\n}\n\n.rbc-time-content>.rbc-time-gutter {\n    -webkit-flex: none;\n    -ms-flex: none;\n    flex: none;\n}\n\n.rbc-time-content>*+*>* {\n    border-left: 1px solid #ddd;\n}\n\n.rbc-rtl .rbc-time-content>*+*>* {\n    border-left-width: 0;\n    border-right: 1px solid #ddd;\n}\n\n.rbc-time-content>.rbc-day-slot {\n    width: 100%;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-user-select: none;\n}\n\n.rbc-current-time-indicator {\n    position: absolute;\n    z-index: 3;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background-color: #74ad31;\n    pointer-events: none;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n    margin-left: -8px;\n    position: absolute;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow,\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n    box-sizing: content-box;\n    position: absolute;\n    border: 8px solid transparent;\n    height: 0;\n    width: 1px;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n    content: \"\";\n    z-index: -1;\n    border-width: 8px;\n    left: -8px;\n    border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle {\n    top: 0;\n    margin-top: -8px;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle,\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before {\n    border-top: none;\n    border-bottom-color: #f0f0f0;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle::before {\n    top: -1px;\n    border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n    bottom: 0;\n    margin-bottom: -8px;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle,\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow,\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n    border-bottom: none;\n    border-top-color: #fff;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] .react-datepicker__triangle::before,\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n    bottom: -1px;\n    border-top-color: #aeaeae;\n}\n\n.react-datepicker-wrapper {\n    display: inline-block;\n}\n\n.react-datepicker {\n\n    font-size: 0.8rem;\n    background-color: #fff;\n    color: #000;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    display: inline-block;\n    position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n    left: 35px;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n    border-left: 0;\n}\n\n.react-datepicker--time-only .react-datepicker__time {\n    border-radius: 0.3rem;\n}\n\n.react-datepicker--time-only .react-datepicker__time-box {\n    border-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n    position: absolute;\n    left: 50px;\n}\n\n.react-datepicker-popper {\n    z-index: 1;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] {\n    margin-top: 10px;\n}\n\n.react-datepicker-popper[data-placement^=\"top\"] {\n    margin-bottom: 10px;\n}\n\n.react-datepicker-popper[data-placement^=\"right\"] {\n    margin-left: 8px;\n}\n\n.react-datepicker-popper[data-placement^=\"right\"] .react-datepicker__triangle {\n    left: auto;\n    right: 42px;\n}\n\n.react-datepicker-popper[data-placement^=\"left\"] {\n    margin-right: 8px;\n}\n\n.react-datepicker-popper[data-placement^=\"left\"] .react-datepicker__triangle {\n    left: 42px;\n    right: auto;\n}\n\n.react-datepicker__header {\n    text-align: center;\n    background-color: #f0f0f0;\n    border-bottom: 1px solid #aeaeae;\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n    padding-top: 8px;\n    position: relative;\n}\n\n.react-datepicker__header--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n    display: inline-block;\n    margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header {\n    margin-top: 0;\n    color: #000;\n    font-weight: bold;\n    font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.react-datepicker__navigation {\n    background: none;\n    line-height: 1.7rem;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 10px;\n    padding: 0;\n    border: 0.45rem solid transparent;\n    z-index: 1;\n    height: 10px;\n    width: 10px;\n    text-indent: -999em;\n    overflow: hidden;\n}\n\n.react-datepicker__navigation--previous {\n    left: 10px;\n    border-right-color: #ccc;\n}\n\n.react-datepicker__navigation--previous:hover {\n    border-right-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--previous--disabled,\n.react-datepicker__navigation--previous--disabled:hover {\n    border-right-color: #e6e6e6;\n    cursor: default;\n}\n\n.react-datepicker__navigation--next {\n    right: 10px;\n    border-left-color: #ccc;\n}\n\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n    right: 80px;\n}\n\n.react-datepicker__navigation--next:hover {\n    border-left-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--next--disabled,\n.react-datepicker__navigation--next--disabled:hover {\n    border-left-color: #e6e6e6;\n    cursor: default;\n}\n\n.react-datepicker__navigation--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.react-datepicker__navigation--years-previous {\n    top: 4px;\n    border-top-color: #ccc;\n}\n\n.react-datepicker__navigation--years-previous:hover {\n    border-top-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--years-upcoming {\n    top: -4px;\n    border-bottom-color: #ccc;\n}\n\n.react-datepicker__navigation--years-upcoming:hover {\n    border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__month-container {\n    float: left;\n}\n\n.react-datepicker__month {\n    margin: 0.4rem;\n    text-align: center;\n}\n\n.react-datepicker__time-container {\n    float: right;\n    border-left: 1px solid #aeaeae;\n    width: 70px;\n}\n\n.react-datepicker__time-container--with-today-button {\n    display: inline;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -72px;\n    top: 0;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background: white;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n    width: 70px;\n    overflow-x: hidden;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n    list-style: none;\n    margin: 0;\n    height: calc(195px + (1.7rem / 2));\n    overflow-y: scroll;\n    padding-right: 0px;\n    padding-left: 0px;\n    width: 100%;\n    box-sizing: content-box;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n    height: 30px;\n    padding: 5px 10px;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n    cursor: pointer;\n    background-color: #f0f0f0;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n    background-color: #216ba5;\n    color: white;\n    font-weight: bold;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n    background-color: #216ba5;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n    color: #ccc;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n}\n\n.react-datepicker__week-number {\n    color: #ccc;\n    display: inline-block;\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n    cursor: pointer;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n    white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n    color: #000;\n    display: inline-block;\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n}\n\n.react-datepicker__day {\n    cursor: pointer;\n}\n\n.react-datepicker__day:hover {\n    border-radius: 0.3rem;\n    background-color: #f0f0f0;\n}\n\n.react-datepicker__day--today {\n    font-weight: bold;\n}\n\n.react-datepicker__day--highlighted {\n    border-radius: 0.3rem;\n    background-color: #3dcc4a;\n    color: #fff;\n}\n\n.react-datepicker__day--highlighted:hover {\n    background-color: #32be3f;\n}\n\n.react-datepicker__day--highlighted-custom-1 {\n    color: magenta;\n}\n\n.react-datepicker__day--highlighted-custom-2 {\n    color: green;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range {\n    border-radius: 0.3rem;\n    background-color: #216ba5;\n    color: #fff;\n}\n\n.react-datepicker__day--selected:hover,\n.react-datepicker__day--in-selecting-range:hover,\n.react-datepicker__day--in-range:hover {\n    background-color: #1d5d90;\n}\n\n.react-datepicker__day--keyboard-selected {\n    border-radius: 0.3rem;\n    background-color: #2a87d0;\n    color: #fff;\n}\n\n.react-datepicker__day--keyboard-selected:hover {\n    background-color: #1d5d90;\n}\n\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {\n    background-color: rgba(33, 107, 165, 0.5);\n}\n\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {\n    background-color: #f0f0f0;\n    color: #000;\n}\n\n.react-datepicker__day--disabled {\n    cursor: default;\n    color: #ccc;\n}\n\n.react-datepicker__day--disabled:hover {\n    background-color: transparent;\n}\n\n.react-datepicker__input-container {\n    position: relative;\n    display: inline-block;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n    border: 1px solid transparent;\n    border-radius: 0.3rem;\n}\n\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n    cursor: pointer;\n}\n\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n    border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n    border-top-color: #ccc;\n    float: right;\n    margin-left: 20px;\n    top: 8px;\n    position: relative;\n    border-width: 0.45rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n    background-color: #f0f0f0;\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    z-index: 1;\n    text-align: center;\n    border-radius: 0.3rem;\n    border: 1px solid #aeaeae;\n}\n\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n    cursor: pointer;\n}\n\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n    line-height: 20px;\n    width: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n    background-color: #ccc;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n    border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n    position: absolute;\n    left: 15px;\n}\n\n.react-datepicker__close-icon {\n    background-color: transparent;\n    border: 0;\n    cursor: pointer;\n    outline: 0;\n    padding: 0;\n    vertical-align: middle;\n    position: absolute;\n    height: 16px;\n    width: 16px;\n    top: 25%;\n    right: 7px;\n}\n\n.react-datepicker__close-icon::after {\n    background-color: #216ba5;\n    border-radius: 50%;\n    bottom: 0;\n    box-sizing: border-box;\n    color: #fff;\n    content: \"\\00d7\";\n    cursor: pointer;\n    font-size: 12px;\n    height: 16px;\n    width: 16px;\n    line-height: 1;\n    margin: -8px auto 0;\n    padding: 2px;\n    position: absolute;\n    right: 0px;\n    text-align: center;\n}\n\n.react-datepicker__today-button {\n    background: #f0f0f0;\n    border-top: 1px solid #aeaeae;\n    cursor: pointer;\n    text-align: center;\n    font-weight: bold;\n    padding: 5px 0;\n    clear: left;\n}\n\n.react-datepicker__portal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    left: 0;\n    top: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 2147483647;\n}\n\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n}\n\n@media (max-width: 400px),\n(max-height: 550px) {\n\n    .react-datepicker__portal .react-datepicker__day-name,\n    .react-datepicker__portal .react-datepicker__day,\n    .react-datepicker__portal .react-datepicker__time-name {\n        width: 2rem;\n        line-height: 2rem;\n    }\n}\n\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n    font-size: 1.44rem;\n}\n\n.react-datepicker__portal .react-datepicker__navigation {\n    border: 0.81rem solid transparent;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous {\n    border-right-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n    border-right-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled,\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n    border-right-color: #e6e6e6;\n    cursor: default;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next {\n    border-left-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n    border-left-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next--disabled,\n.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n    border-left-color: #e6e6e6;\n    cursor: default;\n}\n\n.react-confirm-alert-blur {\n    filter: url(#gaussian-blur);\n    filter: blur(2px);\n    -webkit-filter: blur(2px);\n}\n\n.react-confirm-alert-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 999999999;\n    background-color: rgba(0, 0, 0, 0.6);\n    display: -webkit-flex;\n    display: -moz-flex;\n    display: -ms-flex;\n    display: -o-flex;\n    display: flex;\n    justify-content: center;\n    -ms-align-items: center;\n    align-items: center;\n    opacity: 0;\n    -webkit-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n    -moz-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n    -o-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n    animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;\n}\n\n.react-confirm-alert {\n\n    width: 400px;\n    padding: 30px;\n    text-align: center;\n    background: #fff;\n    border-radius: 10px;\n    box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);\n    color: #666;\n}\n\n.react-confirm-alert-svg {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.react-confirm-alert>h1 {\n    margin-top: 0;\n}\n\n.react-confirm-alert>h3 {\n    margin: 0;\n    font-size: 16px;\n}\n\n.react-confirm-alert-button-group {\n    display: -webkit-flex;\n    display: -moz-flex;\n    display: -ms-flex;\n    display: -o-flex;\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n}\n\n.react-confirm-alert-button-group>button {\n    outline: none;\n    background: #898989;\n    border: none;\n    display: inline-block;\n    padding: 6px 18px;\n    color: #fff;\n    margin-right: 10px;\n    border-radius: 5px;\n    font-size: 12px;\n    cursor: pointer;\n}\n\n.react-confirm-alert-button-group>button:nth-child(1) {\n    outline: none;\n    background: #0088cc;\n    border: none;\n    display: inline-block;\n    padding: 6px 18px;\n    color: #fff;\n    margin-right: 10px;\n    border-radius: 5px;\n    font-size: 12px;\n    cursor: pointer;\n}\n\n@-webkit-keyframes react-confirm-alert-fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@-moz-keyframes react-confirm-alert-fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@-o-keyframes react-confirm-alert-fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes react-confirm-alert-fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.calender-rightside {\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.calender-rightside .ant-select {\n    width: 100%;\n    border-radius: 0px;\n}\n\n.calender-rightside .ant-select-selection {\n    background-color: #e1241a;\n    color: #ffffff;\n    border-radius: 0px;\n}\n\n.calender-rightside .ant-select-arrow {\n    color: #ffffff;\n}\n\n.calender-rightside .item p {\n    color: #000000;\n    font-size: 12px;\n}\n\n.calender-rightside .item p a {\n    width: 20px;\n    display: inline-block;\n    color: green;\n}\n\n.calender-rightside .item p b {\n    font-weight: 400;\n}\n\n.calender-rightside .item p span {\n    background: #ffffff;\n    color: #06b4e0;\n    padding: 2px 5px;\n    font-size: 11px;\n    width: 70px;\n    display: inline-block;\n    text-align: center;\n    float: right;\n}\n\n.soloprofilepage .progressbar {\n    margin-top: 40px;\n}\n\n.soloprofilepage .progressbar .stepwizard-step p {\n    margin-top: 10px;\n    margin-left: -15%;\n    font-size: 10px;\n}\n\n.soloprofilepage .progressbar .stepwizard-step.p2 p {\n    margin-left: -5%;\n}\n\n.soloprofilepage .progressbar .stepwizard-row {\n    display: table-row;\n    width: 100%;\n}\n\n.soloprofilepage .progressbar .stepwizard {\n    display: table;\n    width: 80%;\n    position: relative;\n    margin: auto;\n}\n\n.soloprofilepage .progressbar .stepwizard-step button[disabled] {\n    opacity: 1 !important;\n    filter: alpha(opacity=100) !important;\n}\n\n.soloprofilepage .progressbar .stepwizard-row:before {\n    top: 25%;\n    bottom: 0;\n    position: absolute;\n    content: \" \";\n    width: 68%;\n    height: 1px;\n    background-color: #ccc;\n}\n\n.soloprofilepage .progressbar .stepwizard-step {\n    display: table-cell;\n    position: relative;\n    width: 330px;\n}\n\n.soloprofilepage .progressbar .btn-circle {\n    width: 30px;\n    height: 30px;\n    text-align: center;\n    padding: 6px 0;\n    font-size: 12px;\n    line-height: 1.428571429;\n    border-radius: 15px;\n    background: #f0f1f6;\n}\n\n.soloprofilepage .progressbar .btn-primary {\n    color: #fff;\n    background-color: #e1362d;\n    width: 40px;\n    height: 40px;\n    line-height: 20px;\n    border-radius: 50%;\n    border: 0px;\n    padding: 10px;\n}\n\n.soloprofilepage .progressbar .btn-primary .fa-circle {\n    color: #ffffff;\n}\n\n.soloprofilepage .progressbar .fa-circle {\n    color: #e1362d;\n}\n\n.myModalconfirmdes .close {\n    float: inherit;\n    background: #dadbe6;\n    opacity: 1;\n    display: block;\n    margin: auto;\n    margin-right: 0px;\n    margin-top: 10px;\n    color: #ffffff;\n    padding: 0px 0px 5px 0px;\n    width: 35px;\n    border-radius: 50%;\n    height: 35px;\n    line-height: 30px;\n    text-align: center;\n    top: 0px;\n    position: absolute;\n    font-size: 35px;\n    font-weight: 100;\n    right: 10px;\n}\n\n.myModalconfirmdes .close:hover,\n.myModalconfirmdes .close:focus {\n    opacity: 1 !important;\n    background: #bcbaba;\n    outline: 0px;\n}\n\n.myModalconfirmdes .modal-content {\n    background: #f0f1f7;\n    border-radius: 10px;\n    width: 600px;\n    margin: auto;\n    border: 0px;\n    margin-top: 20px;\n}\n\n.myModalconfirmdes .modal-content.modal-content22 {\n    color: #e1362d;\n    font-size: 32px;\n    text-align: center;\n    margin: 0 10px;\n    width: calc(100% - 20px);\n    border-radius: 0px;\n    padding: 10px 0;\n    margin-bottom: 2px;\n    background: transparent;\n    border: 0px;\n    padding-top: 30px;\n}\n\n.myModalconfirmdes .modal-content.modal-content22 b {\n    font-weight: normal;\n}\n\n.myModalconfirmdes .modal-title {\n    font-size: 28px;\n    font-weight: 400;\n    padding-right: 20px;\n}\n\n.myModalconfirmdes p {\n    margin: 0px;\n    padding-top: 10px;\n}\n\n.myModalconfirmdes p.p1 {\n    font-size: 12px;\n    font-weight: bold;\n \n}\n\n.myModalconfirmdes p.p2 {\n    background: #fff;\n    padding: 5px 10px;\n    color: #cac7c7;\n    border: 1px solid #cccccc;\n    border-radius: 0px;\n\n}\n\n.myModalconfirmdes p.p2select {\n    padding: 0px;\n    color: #cac7c7;\n    border: 0px solid #cccccc;\n}\n\n.myModalconfirmdes p.p2select .custom-select {\n    border-radius: 0px;\n    color: #cac7c7;\n    height: 32px;\n    padding: 4px 10px;\n}\n\n.myModalconfirmdes p.p2select input {\n    border-radius: 0px;\n    color: #cac7c7;\n    height: 32px;\n    padding: 4px 10px;\n}\n\n.myModalconfirmdes .row.no-gutters {\n    border-bottom: 1px solid #cccccc;\n    padding: 10px 0px;\n    margin: 0px 10px;\n}\n\n.myModalconfirmdes .row.no-gutters:last-child {\n    border: 0px;\n}\n\n.myModalconfirmdes p.p3 {\n    text-align: right;\n    font-size: 18px;\n    font-weight: 600;\n    color: #8a8383;\n\n}\n\n.myModalconfirmdes p.p3.p3new {\n    padding: 0px;\n    text-align: center;\n}\n\n#myModalService.myModalconfirmdes p.p3 {\n    padding: 0px;\n    font-size: 15px;\n    line-height: 2.2;\n}\n\n.myModalconfirmdes .timings span {\n    line-height: 2.2;\n}\n\n.myModalconfirmdes .timings p.p2select {\n    float: right;\n    width: 75%;\n}\n\n#update-event.myModalconfirmdes ul,\n#myModalService.myModalconfirmdes ul {\n    padding: 0px;\n    text-align: right;\n}\n\n.myModalconfirmdes ul li {\n    display: inline-block;\n    padding: 1px 4px;\n    background: #ffffff;\n    border-radius: 50%;\n    height: 30px;\n    width: 30px;\n    line-height: 27px;\n    text-align: center;\n    border: 1px solid #cccccc;\n}\n\n.myModalconfirmdes ul li a {\n    display: block;\n    color: #827d7d;\n    text-decoration: none;\n    font-size: 14px;\n}\n\n.myModalconfirmdes ul li.active {\n    background: #dcd9d9;\n    border-color: #2f2c2c;\n}\n\n.myModalconfirmdes ul li.active a {\n    color: #222222;\n    font-weight: 500;\n}\n\n.myModalconfirmdes .modal-header,\n.myModalconfirmdes .modal-footer {\n    background: #ffffff;\n    padding-bottom: 5px;\n}\n\n#scheduleappointment .fc-button-primary {\n    background: transparent;\n    border: 0px;\n    color: #071822;\n    text-transform: capitalize;\n    font-size: 16px;\n    padding: 5px 15px;\n    letter-spacing: 1px;\n}\n\n#scheduleappointment .fc-button-primary.fc-button-active,\n#scheduleappointment .fc-button-primary:not(:disabled):active:focus,\n#scheduleappointment .fc-button-primary:not(:disabled).fc-button-active:focus,\n#scheduleappointment .fc-button-primary:hover {\n    box-shadow: 0px 2px 5px #636363;\n    background-color: #e1241a;\n    color: #ffffff;\n    border-radius: 30px;\n    outline: 0px;\n    opacity: 1;\n}\n\n#scheduleappointment .fc-toolbar h2 {\n    margin: 0;\n    font-size: 16px;\n}\n\n#scheduleappointment .fc-timeGrid-view .fc-day-grid {\n    display: none;\n}\n\n#scheduleappointment hr.fc-divider {\n    display: none;\n}\n\n#scheduleappointment .fc-nonbusiness {\n    background: #cecece;\n}\n\n#scheduleappointment .fc-event .fc-content {\n    color: #fff;\n    font-size: 12px;\n    text-align: center;\n}\n\n#scheduleappointment .fc {\n    font-size: 1em;\n    box-shadow: 0px 0px 10px #b5b1b1;\n    padding: 5px;\n}\n\n#scheduleappointment .fc-toolbar.fc-header-toolbar {\n    margin-bottom: 5px;\n}\n\n.eventColor {\n    background: #cecece;\n}\n\n.loading {\n    position: fixed;\n    z-index: 999;\n    overflow: show;\n    margin: auto;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    width: 50px;\n    height: 50px;\n}\n\n.loading:before {\n    content: \"\";\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.5);\n}\n\n.loading:not(:required) {\n    font: 0/0 a;\n    color: transparent;\n    text-shadow: none;\n    background-color: transparent;\n    border: 0;\n}\n\n.loading:not(:required):after {\n    content: \"\";\n    display: block;\n    background: url('../../../../public/assets/images/page_loader.svg');\n    height: 35px;\n    width: 35px;\n    background-size: cover;\n    padding: 40px !important;\n    animation: none;\n    border: none;\n    z-index: 999;\n    position: relative;\n}\n\n@-webkit-keyframes spinner {\n    0% {\n        -webkit-transform: rotate(0deg);\n        -moz-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n        -o-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@-moz-keyframes spinner {\n    0% {\n        -webkit-transform: rotate(0deg);\n        -moz-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n        -o-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@-o-keyframes spinner {\n    0% {\n        -webkit-transform: rotate(0deg);\n        -moz-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n        -o-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes spinner {\n    0% {\n        -webkit-transform: rotate(0deg);\n        -moz-transform: rotate(0deg);\n        -ms-transform: rotate(0deg);\n        -o-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n        -moz-transform: rotate(360deg);\n        -ms-transform: rotate(360deg);\n        -o-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n.main_content.soloprofilepage {\n    background: #ffffff;\n    margin-top: 80px;\n}\n\nul.indicators {\n    list-style-type: none;\n    padding: 0px;\n    margin-top: 15px;\n}\n\nul.indicators li {\n    padding: 5px 0px;\n}\n\nul.indicators li.one .fa-square {\n    color: #808080;\n}\n\nul.indicators li.two .fa-square {\n    color: #3788d8;\n}\n\nul.indicators li.three .fa-square {\n    color: #f2c9ca;\n}\n\nul.indicators li.four .fa-square {\n    color: #5bff31;\n}\n\nul.indicators li.green .fa-square {\n    color: #3788d8;\n}\n\nul.indicators li.white .fa-square {\n    color: #ffffff;\n}\n\n.main_cal_indicate ul.indicators li.four span {\n    background: repeating-linear-gradient(45deg,\n            #93fa93,\n            #93fa93 8px,\n            #93fa93 8px,\n            #93fa93 20px);\n}\n\n.main_cal_indicate ul.indicators li.two span {\n    background: repeating-linear-gradient(45deg,\n            #3788d8,\n            #3788d8 8px,\n            #3788d8 8px,\n            #3788d8 20px);\n}\n\n@media (max-width: 1300px) {\n    .myModalconfirmdes .modal-content.modal-content22 {\n        font-size: 25px;\n    }\n\n    .myModalconfirmdes .modal-title {\n        font-size: 20px;\n    }\n\n    .myModalconfirmdes .modal-header img {\n        width: 35px;\n    }\n\n    .myModalconfirmdes .row.no-gutters {\n        padding: 5px 10px;\n    }\n\n    .myModalconfirmdes p.p2 {\n        height: 32px;\n        padding: 3px 10px;\n    }\n}\n\n@media (max-width: 1100px) {\n    #scheduleappointment .fc-button-primary {\n        font-size: 12px;\n        padding: 3px 10px;\n    }\n\n    #scheduleappointment .fc-toolbar h2 {\n        font-size: 12px;\n    }\n\n    .calender-rightside .item p {\n        display: flex;\n        justify-content: space-between;\n        text-align: center;\n        font-size: 10px;\n    }\n\n    .calender-rightside .item p span {\n        height: 20px;\n    }\n}\n\n@media (min-width: 991px) {\n    #update-event.myModalconfirmdes .modal-dialog {\n        height: 500px;\n        width: 850px;\n    }\n\n    #myModalService.myModalconfirmdes .modal-dialog {\n        height: 530px;\n        width: 850px;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    #scheduleappointment .fc-button-primary {\n        font-size: 10px;\n        padding: 3px 10px;\n    }\n\n    #scheduleappointment .fc-toolbar h2 {\n        font-size: 10px;\n    }\n\n    .fc th {\n        font-size: 10px;\n    }\n\n    .fc-ltr .fc-axis {\n        font-size: 11px;\n        text-align: center;\n    }\n\n    .calender-rightside .item p span {\n        display: block;\n        width: 100%;\n        margin-top: 5px;\n        float: inherit;\n    }\n\n    .calender-rightside .item p {\n        font-size: 9px;\n        font-weight: bold;\n        display: block;\n    }\n\n    .soloprofilepage .progressbar .stepwizard {\n        width: 100%;\n    }\n\n    .soloprofilepage .progressbar .stepwizard-step p {\n        font-weight: bold;\n        font-size: 10px;\n    }\n\n    .soloprofilepage .profiletabone .property-rrswatch a {\n        font-size: 10px;\n    }\n\n    .soloprofilepage .profiletabone .property-rrswatch label {\n        position: relative;\n        top: 4px;\n    }\n\n    .soloprofilepage .profiletabone i {\n        padding-top: 10px;\n        padding-bottom: 20px;\n        font-size: 10px;\n        color: #8a8585;\n        text-align: center;\n        font-weight: 700;\n    }\n\n    ul.indicators li .fa-square {\n        float: left;\n        margin: 4px 10px 14px 0px;\n    }\n\n    ul.indicators li {\n        padding: 7px 0px;\n    }\n}\n\n.myModalconfirmdes .modal-dialog {\n    height: calc(100vh - 80px);\n}\n\n@media screen and (max-width: 767px) {\n    .myModalconfirmdes .modal-content {\n        width: 100%;\n    }\n\n    .myModalconfirmdes .modal-content.modal-content22 {\n        font-size: 18px;\n    }\n\n    .myModalconfirmdes .close {\n        width: 27px;\n        height: 28px;\n        line-height: 28px;\n        font-size: 20px;\n    }\n\n    .myModalconfirmdes .modal-title {\n        font-size: 15px;\n        font-weight: 600;\n    }\n\n    .myModalconfirmdes p.p2 {\n        margin-bottom: 10px;\n    }\n\n    .myModalconfirmdes p {\n        text-align: center;\n    }\n\n    .myModalconfirmdes p.p3 {\n        text-align: center;\n    }\n\n    .myModalconfirmdes .modal-dialog {\n        height: auto;\n    }\n\n    #moveDelete .modal-title {\n        font-size: 15px;\n        font-weight: 700;\n    }\n\n    #moveDelete .input-group {\n        flex-direction: column;\n    }\n\n    #moveDelete .react-datepicker__input-container,\n    #moveDelete .input-group-prepend {\n        display: block;\n    }\n\n    .react-confirm-alert {\n        width: 90%;\n    }\n\n    .main_content.soloprofilepage {\n        margin-top: 60px;\n    }\n}\n\n@media (max-width: 580px) {\n    .fc-toolbar.fc-header-toolbar {\n        flex-direction: column;\n    }\n\n    .fc-toolbar.fc-header-toolbar .fc-left {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .fc-toolbar.fc-header-toolbar .fc-right {\n        width: 100%;\n    }\n\n    .fc-toolbar.fc-header-toolbar .fc-right .fc-button-group {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .fc-toolbar.fc-header-toolbar .fc-center {\n        margin-bottom: 10px;\n    }\n}\n\n@media (min-width: 320px) {\n    .myModalconfirmdes .modal-dialog {\n        max-width: 80%;\n        margin: 1.75rem auto;\n        margin-top: 50px;\n        background: #ffffff;\n    }\n}\n\n#moveDelete .input-group-prepend {\n    float: left;\n    margin-bottom: 15px;\n}\n\n#moveDelete .react-datepicker-wrapper {\n    width: 100%;\n}\n\n#moveDelete .react-datepicker__input-container {\n    width: 100%;\n}\n\n#moveDelete .col-form-label {\n    text-align: right;\n}\n\n.new_modal_pop .form-para {\n  \n    margin-bottom: 20px;\n}\n\n.new_modal_pop .form-para span {\n  \n    font-size: 13px;\n    color: #909090;\n}\n\n.new_modal_pop .form-para p {\n  \n    font-size: 16px;\n    color: #000000;\n    margin-bottom: 0px;\n}\n\n.new_modal_pop .form-para p.p2 {\n    height: 38px;\n    background: #ffffff;\n    border: 1px solid #cccccc;\n    padding: 7px 10px;\n    border-radius: 5px;\n    color: #4e4e4e;\n}\n\n.new_modal_pop .form-para ul {\n    padding: 0px;\n    margin: 0px;\n    list-style-type: none;\n    margin-top: 10px;\n}\n\n.new_modal_pop .form-para ul li {\n    display: inline-block;\n}\n\n.new_modal_pop .form-para ul li a {\n    display: block;\n    background: #9c9c9c;\n    color: #ffffff;\n    padding: 5px;\n    border-radius: 50%;\n    margin-right: 10px;\n    margin-left: 0px;\n    width: 30px;\n    height: 30px;\n    font-size: 13px;\n    text-align: center;\n    line-height: 20px;\n  \n}\n\n.new_modal_pop .form-para ul li a:hover {\n    color: #ffffff;\n}\n\n.new_modal_pop .form-para ul li.active a {\n    background: #e32726;\n}\n\n.main_cal_indicate ul.indicators li {\n    display: inline-block;\n    margin-right: 15px;\n}\n\n#moveDelete.modal .main-pop h4.modal-title {\n  \n    font-size: 18px;\n    padding: 20px 10px;\n    font-weight: 400;\n    text-align: center;\n    color: #b7b7b7;\n    margin-bottom: 10px;\n    padding-top: 0px;\n}\n\n#moveDelete.modal .main-pop .form-group {\n    position: relative;\n    margin-bottom: 18px;\n    padding-top: 20px;\n}\n\n#moveDelete.modal .main-pop .form-group label {\n    position: absolute;\n    top: -3px;\n    left: 0;\n    z-index: 9;\n    font-size: 14px;\n    color: #000000;\n    \n    font-weight: 500;\n    padding: 0px;\n}\n\n#moveDelete.modal .main-pop .form-group .form-control {\n    margin-bottom: 0px;\n}\n\n#moveDelete.modal .main-pop .form-group .custom-select {\n    height: 42px;\n    padding: 0.375rem 0.75rem;\n    padding-left: 16px;\n    border: 1px solid #bfbfbf;\n    outline: 0px;\n    box-shadow: none;\n}\n\n#moveDelete.modal .main-pop .form-group.form-group2 label {\n  \n    position: initial;\n    padding-left: 0px;\n    font-size: 14px;\n    color: #a7a7a7;\n    padding-bottom: 0px;\n    margin: 0px;\n}\n\n#moveDelete.modal .main-pop .form-group.form-group2 {\n    margin-bottom: 0px;\n}\n\n#moveDelete.modal .main-pop .form-group.form-group2 p {\n  \n    color: #030c10;\n    font-size: 16px;\n    margin-top: -5px;\n    margin-bottom: 5px;\n}\n\n#moveDelete.modal .accordion .card-header:after {\n    font-family: \"FontAwesome\", sans-serif;\n    float: right;\n    content: \"-\";\n    font-size: 23px;\n    line-height: 20px;\n}\n\n#moveDelete.modal .accordion .card-header.collapsed:after {\n    content: \"+\";\n}\n\n#moveDelete.modal .accordion .card .card-header {\n  \n    font-size: 18px;\n    padding: 6px 10px;\n    font-weight: 300;\n    text-align: left;\n    color: #b7b7b7;\n    margin-bottom: 0;\n    background: transparent;\n}\n\n#moveDelete.modal .accordion .card .card-header .card-title {\n  \n    font-size: 18px;\n    font-weight: 300;\n    text-align: left;\n    color: #b7b7b7;\n}\n\n#moveDelete.modal .accordion .card-body {\n    padding: 10px 10px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n#moveDelete.modal .btn {\n    padding: 4px 20px;\n    font-size: 15px;\n\n    border: 1px solid #dc3545;\n    outline: 0px;\n    box-shadow: none;\n}\n\n#moveDelete.modal .btn.btn-danger {\n    background: #d02f22;\n}\n\n#moveDelete.modal .btn.btn-danger:hover {\n    background: #ffffff;\n    color: #d02f22;\n}\n\n#moveDelete.modal .btn.btn-primary {\n    background: #007bff;\n    border-color: #007bff;\n}\n\n#moveDelete.modal .btn.btn-primary:hover {\n    background: #ffffff;\n    border-color: #007bff;\n    color: #007bff;\n}\n\n.new_modal_pop ul.appoint_list {\n    padding: 0px;\n    margin: 0px;\n}\n\n.new_modal_pop ul.appoint_list li {\n    position: relative;\n    list-style-type: none;\n}\n\n.new_modal_pop ul.appoint_list li a {\n    position: relative;\n    display: block;\n    height: 40px;\n    line-height: 40px;\n    padding: 0;\n    padding-left: 16px;\n    padding-right: 56px;\n    text-decoration: none;\n    font-weight: 400;\n    white-space: nowrap;\n    color: #d0d0d0;\n    font-size: 17px;\n    \n    border: 1px dashed #ededed;\n}\n\n.new_modal_pop ul.appoint_list li a span {\n    position: absolute;\n    right: 16px;\n    top: 0;\n    color: #717171;\n}\n\n.new_modal_pop hr {\n    position: relative;\n    clear: both;\n    margin-top: 30px;\n    margin-bottom: 30px;\n    outline: none;\n    border-top: 1px solid #ededed;\n}\n\n.new_modal_pop .new_inputt input {\n    width: 100%;\n    border: 1px solid #efefef;\n    padding: 5px 10px;\n    margin-bottom: 20px;\n    height: 40px;\n    color: #888888;\n    outline: 0px;\n}\n\n#showDetails.new_modal_pop .ul_select_list {\n    flex-direction: row;\n}\n\n#update-event .main-pop .form-group {\n    position: relative;\n    margin-bottom: 18px;\n    padding-top: 20px;\n}\n\n#update-event .main-pop .col-form-label {\n    position: absolute;\n    top: -3px;\n    left: 0;\n    z-index: 9;\n    font-size: 14px;\n    color: #000000;\n    \n    font-weight: 500;\n    padding: 0px;\n}\n/* #update-event .main-pop .form-group .form-para li.active{\n    color: #0087ff;\n} */\n\n#update-event .main-pop .form-group .custom-select {\n    height: 42px;\n    padding: 0.375rem 0.75rem;\n    padding-left: 16px;\n    border: 1px solid #bfbfbf;\n    outline: 0px;\n    box-shadow: none;\n}\n\n#update-event .main-pop .form-group .form-control {\n    border: solid 1px rgba(0, 0, 0, 0.2);\n    height: 43px;\n    outline: 0px;\n    box-shadow: none !important;\n    border-radius: 6px;\n    margin-bottom: 0px;\n    line-height: 30px;\n}\n\n\n.calendar-view-page-schedule .fc .fc-scroller{\n    overflow: initial !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
